import { Dialog as NativeDialog } from '@progress/kendo-react-dialogs';
import React, { FC, ReactNode, useEffect, useRef } from 'react';
import useAuth from 'src/hooks/useAuth';
import useRemoveScrollbar from 'src/hooks/useRemoveScrollbar';

interface DialogProps {
  open: boolean;
  onClose: VoidFunction;
  children: ReactNode;
  closeIcon?: boolean;
  width?: number | string;
  height?: number | string;
  title?: string | React.ReactElement<any>;
  className?: string;
  id?: string;
}

let openModalRefs: Record<string, any>[] = [];

const Dialog: FC<DialogProps> = ({ open, children, closeIcon = true, ...other }) => {
  const { isShuster } = useAuth();
  const dialogRef = useRef(null);

  useRemoveScrollbar(open);

  const setFocus = (ref: any) => {
    if (ref.element) {
      const closeButton = ref.element.querySelector('.k-window-actions, .k-dialog-actions');
      if (closeButton) {
        const button = closeButton.querySelector('button');
        if (button) {
          button.focus();
        }
      }
    }
  };

  useEffect(() => {
    const currentDialogRef = dialogRef.current as any;
    if (open && currentDialogRef) {
      openModalRefs.push(currentDialogRef);
      setFocus(currentDialogRef);
    }
    return () => {
      // Remove this modal from the stack when it unmounts/closes
      openModalRefs =
        openModalRefs.length > 0
          ? openModalRefs.filter((el) => el.contentId !== currentDialogRef?.contentId)
          : [];
      // Focus the last open modal, if any
      const lastModalRef =
        openModalRefs.length > 0 ? openModalRefs?.[openModalRefs.length - 1] : null;
      if (lastModalRef) {
        setFocus(lastModalRef);
      }
    };
  }, [open]);

  return (
    <>
      {open && (
        <NativeDialog
          {...other}
          id={other.id === 'modal' && isShuster ? 'shuster-modal' : other.id}
          closeIcon={closeIcon}
          autoFocus={true}
          ref={dialogRef}
        >
          {children}
        </NativeDialog>
      )}
    </>
  );
};

export default Dialog;
